var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-unlocked-03"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 13.1667C3.33398 11.7665 3.33398 11.0665 3.60647 10.5317C3.84615 10.0613 4.2286 9.67883 4.69901 9.43915C5.23379 9.16667 5.93385 9.16667 7.33398 9.16667H12.6673C14.0674 9.16667 14.7675 9.16667 15.3023 9.43915C15.7727 9.67883 16.1552 10.0613 16.3948 10.5317C16.6673 11.0665 16.6673 11.7665 16.6673 13.1667V13.5C16.6673 14.9001 16.6673 15.6002 16.3948 16.135C16.1552 16.6054 15.7727 16.9878 15.3023 17.2275C14.7675 17.5 14.0674 17.5 12.6673 17.5H7.33398C5.93385 17.5 5.23379 17.5 4.69901 17.2275C4.2286 16.9878 3.84615 16.6054 3.60647 16.135C3.33398 15.6002 3.33398 14.9001 3.33398 13.5V13.1667Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 9.16667V6.66667C5.83398 4.36548 7.69946 2.5 10.0007 2.5C12.0164 2.5 13.6979 3.93147 14.084 5.83333M7.33398 17.5H12.6673C14.0674 17.5 14.7675 17.5 15.3023 17.2275C15.7727 16.9878 16.1552 16.6054 16.3948 16.135C16.6673 15.6002 16.6673 14.9001 16.6673 13.5V13.1667C16.6673 11.7665 16.6673 11.0665 16.3948 10.5317C16.1552 10.0613 15.7727 9.67883 15.3023 9.43915C14.7675 9.16667 14.0674 9.16667 12.6673 9.16667H7.33398C5.93385 9.16667 5.23379 9.16667 4.69901 9.43915C4.2286 9.67883 3.84615 10.0613 3.60647 10.5317C3.33398 11.0665 3.33398 11.7665 3.33398 13.1667V13.5C3.33398 14.9001 3.33398 15.6002 3.60647 16.135C3.84615 16.6054 4.2286 16.9878 4.69901 17.2275C5.23379 17.5 5.93385 17.5 7.33398 17.5Z",
    stroke: "#525252",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock-icon.512a8310c1cf6a92f57f0c1d15a788cb.svg";
export { ForwardRef as ReactComponent };